import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: center;
	justify-content: flex-start;
	overflow: hidden;

	background-color: ${color.interface.white};
	border-radius: 5px;

	@media (max-width: 1100px) {
		min-height: fit-content;
	}
`;

export const centralize = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;
	border-radius: 5px;
	background-color: ${color.interface.white};
`;

export const boxItem = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const itemCellphone = styled.div<{
	$isDragging: boolean;
}>`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	background-color: ${(props) =>
		props.$isDragging ? 'lightgreen' : color.interface.white};
`;

export const containerListCellphone = styled.div<{ $isDraggingOver: boolean }>`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	overflow: auto;
	background-color: ${(props) =>
		props.$isDraggingOver
			? color.interface.lightBlue2
			: color.interface.backgroundHome};
	::-webkit-scrollbar {
		display: none; /* Oculta a barra de rolagem */
	}
`;

export const noDataText = styled.p`
	font-size: 1.4rem;
	color: ${color.interface.darkgray};
	font-family: nunito-bold;
`;

export const saveBtn = styled.div<{ $listAreEqual: boolean }>`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;
	gap: 1rem;
	background-color: ${(props) =>
		props.$listAreEqual ? color.system.success : color.system.info};
	cursor: ${(props) => (props.$listAreEqual ? 'not-allowed' : 'pointer')};

	> svg {
		font-size: 2rem;
		color: ${color.interface.white};
	}

	> button {
		all: unset;
		text-align: center;
		text-transform: uppercase;
		font-weight: 900;
		color: ${color.interface.white};
		font-size: 1.4rem;
	}

	animation: ${(props) =>
		props.$listAreEqual ? 'none' : 'shine alternate-reverse ease 1s infinite;'};

	@keyframes shine {
		from {
			opacity: 0.2;
		}
		to {
			opacity: 1;
		}
	}

	@media (max-height: 650px) {
		padding: 0.5rem;

		> button {
			font-size: 1rem;
		}

		> svg {
			font-size: 1.3rem;
		}
	}
`;

export const optionsItem = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: ${color.interface.white};
	animation: show 0.5s linear;
	transition: all ease 0.5s;
	padding-left: 1rem;

	@keyframes show {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	> p {
		font-size: 1.4rem;
		color: ${color.interface.darkgray};
	}

	> div {
		> button {
			all: unset;
			text-align: center;
			padding: 0.5rem;

			> p {
				font-size: 1.4rem;
			}
		}
	}

	-webkit-box-shadow: 0px 8px 17px -13px rgba(0, 0, 0, 0.75);
	-moz-box-shadow: 0px 8px 17px -13px rgba(0, 0, 0, 0.75);
	box-shadow: 0px 8px 17px -13px rgba(0, 0, 0, 0.75);
`;

export const deleteModule = styled.button`
	> svg {
		color: ${color.interface.lightGray};
		font-size: 2.5rem;
		transition: all ease 0.5s;
		cursor: pointer;
	}

	:hover {
		color: ${color.system.error};
	}
`;

export const editModule = styled.button`
	> svg {
		color: ${color.interface.lightGray};
		font-size: 2.5rem;
		transition: all ease 0.5s;
		cursor: pointer;
	}

	:hover {
		color: ${color.system.info};
	}
`;
